<template>
    <section class="widget widget--fluid-height">
        <div class="widget__content">
            <p class="widget__content--text">
                {{ $t('registerUsername.disabledRegistration1') }}
                <span class="bold">{{ $t('registerUsername.disabledRegistration2') }}</span>
                {{ $t('registerUsername.disabledRegistration3') }}
            </p>
        </div>
        <download-app class="disabled-register__download"
            :isHorizontal="true"
        />
    </section>
</template>

<script>
import downloadApp from '@webapp/components/download-app/download-app.vue';

export default {
    name: 'disabled-register-widget',
    components: {
        downloadApp,
    },
};
</script>

<style lang="scss" scoped>
.widget {
    &__content {
        padding-bottom: 20px;

        &--text {
            font-style: normal;
            font-size: 15px;
            line-height: 20px;
            color: $black-color;
        }
    }
}
</style>